module.exports = __webpack_public_path__ + "static/flexitem-f328e400b63fcd9fe77705e395e4849b.png";